<template>
  <div class="deviceManger">
    <equipmentRun />
  </div>
</template>

<script>
import equipmentRun from "./components/equipmentRun";


export default {
  name: "deviceOps",
  components: { equipmentRun },
};
</script>

<style scoped lang="less">
.deviceManger {
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  height: 100%;
  overflow: auto;
.title {
  display: flex;
  justify-content: space-between;
.tip {
  display: flex;
  width: 100%;
  justify-content: right;
p {
  margin: 0 16px;
}
}
}
.content {
  padding: 36px;
.query {
  height: 60px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
.font {
  margin: 0 12px 0 20px;
}
.font:nth-child(1) {
  margin-left: 0px;
}
}

.action {
  display: flex;
  position: relative;
p {
  font-size: 14px;
  color: #252b3c;
  font-weight: normal;
}
.export {
  position: absolute;
  left: 263px;
}
.btnGroup {
  position: absolute;
  right: 0;
}
}
.tree-Table {
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
.tree {
  width: 253px;
  height: 62vh;
  overflow-y: auto;
}
.tableList {
  width: 80%;
  height: 60vh;
  overflow: auto;
}
}
}
.deleteDialog {
p {
  margin: 0 0 10px 0;
  height: 30px;
  line-height: 10px;
img {
  margin-right: 12px;
}
}
}
}
@media screen and (min-width: 320px) and (max-width: 1700px){
  .deviceManger .content {
    padding: 36px;
    margin-bottom: 20px;
    .tree-Table{
      padding-top: 72px;
    }
    .query {
      height: 110px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;

    }
  }
}
</style>
